export enum Protocol {
  http = 'http://',
  https = 'https://'
}
